import _tslib from "tslib";
import _exports from "./exports";
import _core from "@sentry/core";
import _utils from "@sentry/utils";
import _integrations from "./integrations";
import _transports from "./transports";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var tslib_1 = _tslib;

tslib_1.__exportStar(_exports, exports);

var core_1 = _core;
var utils_1 = _utils;
var BrowserIntegrations = _integrations;
var Transports = _transports;
exports.Transports = Transports;
var windowIntegrations = {}; // This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any

var _window = utils_1.getGlobalObject();

if (_window.Sentry && _window.Sentry.Integrations) {
  windowIntegrations = _window.Sentry.Integrations;
} // tslint:enable: no-unsafe-any


var INTEGRATIONS = tslib_1.__assign({}, windowIntegrations, core_1.Integrations, BrowserIntegrations);

exports.Integrations = INTEGRATIONS; //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule,
      Integrations = exports.Integrations;
const _Transports = exports.Transports;
export { _Transports as Transports };